export const backgroundColorClasses = {
    accent: 'bg-accent-500',
    info: 'bg-info-600',
    success: 'bg-success-600',
    warning: 'bg-warning-500',
    danger: 'bg-danger-600',
    primary: 'bg-slate-950 dark:bg-white',
    secondary: 'bg-slate-700 dark:bg-white',
    tertiary: 'bg-slate-600 dark:bg-white',
    quaternary: 'bg-slate-500 dark:bg-white',
    black: 'bg-black',
    white: 'bg-white',
    none: '',
};
